exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".service-icon[data-v-2359b990]{cursor:pointer;width:100%;height:100%}", ""]);

